var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdeal = function SvgIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M22.791 37.405v.002H0V3.333h22.791v.002c9.33.13 16.846 6.386 16.846 17.035S32.122 37.275 22.79 37.405"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.59 35.635H1.781V5.106h20.81c8.949.044 15.26 6.006 15.26 15.264 0 9.26-6.311 15.22-15.26 15.265",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M4.16 22.635h5.945v10.636H4.16zm2.973-1.575c2.08 0 3.765-1.676 3.765-3.743 0-2.066-1.686-3.742-3.765-3.742s-3.766 1.676-3.766 3.742c0 2.067 1.686 3.743 3.766 3.743"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E54279",
    d: "M35.418 18.893C34.475 7.47 22.596 7.47 22.596 7.47H13.28v25.802h9.315s12.684 0 12.88-12.605h-4.358v-6.894H32.9v5.121zm-16.984-5.12h4.162v1.772h-2.378v.788h2.18v1.575h-2.18v.985h2.576v1.773h-4.36zm-2.649 3.446c0-1.674-1.117-1.674-1.117-1.674h-1.387v-1.773h1.19s2.972 0 2.972 3.447-2.973 3.447-2.973 3.447h-1.189v-1.773h1.387s1.117 0 1.117-1.674m9.927-3.447h2.433l2.09 6.894h-1.803l-.375-1.31H25.77l-.385 1.31h-1.802zm1.218 1.822.623 2.033h-1.259z"
  })));
};
export default SvgIdeal;